import React from 'react';

export default ({ locale }) => (
  <p style={{ fontSize: '10px' }}>{locale.common.footer}</p>
);
